import { render, staticRenderFns } from "./ModalApproveClaimable.vue?vue&type=template&id=6b8b28a3&"
import script from "./ModalApproveClaimable.vue?vue&type=script&lang=js&"
export * from "./ModalApproveClaimable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports